"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adventureTimestampToWeeks = exports.weeksToAdventureTimestamp = void 0;
const constants_1 = require("../../../constants");
const weeksToAdventureTimestamp = (weeks) => {
    return constants_1.ADVENTURE_START + constants_1.ADVENTURE_DURATION * weeks;
};
exports.weeksToAdventureTimestamp = weeksToAdventureTimestamp;
const adventureTimestampToWeeks = (adventureTimestamp) => Math.floor((adventureTimestamp - constants_1.ADVENTURE_START) / constants_1.ADVENTURE_DURATION);
exports.adventureTimestampToWeeks = adventureTimestampToWeeks;
